<template>
	<!-- 头部 -->
	<div class="main" v-if="webSiteConfig">
		
		<!--头部-->
		<div class="top container">
			<div class="top-wenzi">
				<div class="top-wenzi-l">
					<p>欢迎您访问诚信公证处！</p>
				</div>
				<div class="top-wenzi-r" id="myBtn">
					<button style="color: #B86E05;" v-if="logindata==null" class="top-dl" @click="showlogin">登 录</button>
					<el-dropdown style="color: #B86E05;" trigger="click" v-else  @command="handleCommand">
					  <span style="color: #B86E05;" class="top-dl">
					    {{logindata.wechatPhone}}<i class="el-icon-arrow-down el-icon--right"></i>
					  </span>
					  <el-dropdown-menu slot="dropdown">
					    <el-dropdown-item><router-link style="color: #B86E05;text-decoration:none;" :to="{name:'userhome',params:{page:'1'}}">我的咨询</router-link></el-dropdown-item>
						<el-dropdown-item><router-link style="color: #B86E05;text-decoration:none;" :to="{name:'userhome',params:{page:'2'}}">我的预约</router-link></el-dropdown-item>
						<el-dropdown-item><router-link style="color: #B86E05;text-decoration:none;" :to="{name:'userhome',params:{page:'3'}}">我的申办</router-link></el-dropdown-item>
						<el-dropdown-item><router-link style="color: #B86E05;text-decoration:none;" :to="{name:'userhome',params:{page:'4'}}">修改密码</router-link></el-dropdown-item>
					    <el-dropdown-item command="out" divided>退出登陆</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</div>
		<!-- 登陆模块 -->
		<el-dialog title="欢迎回来" :visible.sync="open" :before-close="handleClose" width="20%" :show-close="false">
			<div class="logins">
				<el-form :model="loginform" :rules="loginrules" ref="loginform" class="login-form">
					<el-form-item prop="phone">
						<el-input v-model="loginform.phone" maxlength="11" placeholder="请输入手机号码">
							<i slot="prefix" class="el-icon-mobile-phone"></i>
						</el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input v-model="loginform.password" type="password" maxlength="20" placeholder="请输入登陆密码">
							<i slot="prefix" class="el-icon-unlock"></i>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="login" type="danger" style="width: 100%;">登 陆</el-button>
					</el-form-item>
				</el-form>
				<div class="register">
					<a style="cursor:pointer" @click="reg">没有账号？现在去注册</a>
					<a style="cursor:pointer" @click="open3 = true" >忘记密码？</a>
				</div>
			</div>
			
			<!-- 注册 -->
			<el-dialog v-if="open2" title="用户注册" :visible.sync="open2" width="25%" :show-close="false" append-to-body>
				<div class="logins">
					<el-form :model="regform" :rules="loginrules" ref="regform" class="regform">
						<el-form-item prop="phone">
							<el-input @change="isreg" v-model="regform.phone" maxlength="11" placeholder="请输入手机号码">
								<i slot="prefix" class="el-icon-mobile-phone"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model="regform.password" type="password" maxlength="20" placeholder="请输入登陆密码">
								<i slot="prefix" class="el-icon-unlock"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="pass">
							<el-input v-model="regform.pass" type="password" maxlength="20" placeholder="请确认登陆密码">
								<i slot="prefix" class="el-icon-unlock"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="code">
							<el-input style="width: 58%;" v-model="regform.code" maxlength="20" placeholder="请输入验证码">
								<i slot="prefix" class="el-icon-message"></i>
							</el-input>
							<el-button :disabled="show" @click="sendregcode" style="width: 30%;padding: 0px 20px;margin-left: 20px;" type="primary">{{sendregmsg}}</el-button>
						</el-form-item>
						<el-form-item>
							<el-button @click="reguser" type="danger" style="width: 100%;">注 册</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
			
			<!-- 忘记密码 -->
			<el-dialog v-if="open3" title="重置密码" :visible.sync="open3" width="26%" :show-close="false" append-to-body>
				<div class="logins">
					<el-form :model="forgetform" :rules="forgetrules" ref="forgetform" class="forgetform">
						<el-form-item prop="phone">
							<el-input v-model="forgetform.phone" maxlength="11" placeholder="请输入手机号码">
								<i slot="prefix" class="el-icon-mobile-phone"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="code">
							<el-input style="width: 58%;" v-model="forgetform.code" maxlength="20" placeholder="请输入验证码">
								<i slot="prefix" class="el-icon-message"></i>
							</el-input>
							<el-button :disabled="show2" @click="sendforgetcode" style="width: 30%;margin-left: 20px;" type="primary">{{sendforgetmsg}}</el-button>
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model="forgetform.password" maxlength="20" placeholder="请输入新密码">
								<i slot="prefix" class="el-icon-unlock"></i>
							</el-input>
						</el-form-item>
						<el-form-item prop="pass">
							<el-input v-model="forgetform.pass" maxlength="20" placeholder="请确认密码">
								<i slot="prefix" class="el-icon-unlock"></i>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="forgetsubmit" type="danger" style="width: 100%;">修改密码</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
		</el-dialog>
		<div class="banner" :style="`background: url(${ banner });background-size: 100% 150%;`">
			<div class="banner-nr container">
				<div class="banner-nr-left">
					<div class="cx-logo"><img :src="hoturl+webSiteConfig.logo" /></div>
					<div class="cx-name">{{webSiteConfig.name}}</div>
					<div class="cx-en-name">&nbsp;{{webSiteConfig.englishName}}</div>
				</div>
				<div class="banner-nr-sousuo">
					<div class="banner-nr-sousuo-top">
						<span v-if="grt=(ho<9?'早上好':
                    ho<12?'上午好':
                    ho<15?'中午好':
                    ho<19?'下午好':
                    '晚上好'
                    )">Hi {{grt}} !</span>
						<p>{{nowTime}} {{nowWeek}}</p>
					</div>
					
				</div>
			</div>
		</div>
		<!--导航-->
		<div class="nav">
			<div class="nav-title container">
				<ul>
					<li>
						<router-link :to="{name:'home'}">首页</router-link>
					</li>
					<li class="drop-down">
						<router-link :to="{name:'Bossspeak',params:{page:'1'}}">机构概况</router-link>
						<ul class="drop-down-content">
							<li>
								<router-link :to="{name:'Bossspeak',params:{page:'1'}}">本处简介</router-link>
							</li>
							<li>
								<router-link :to="{name:'Bossspeak',params:{page:'2'}}">组织架构</router-link>
							</li>
							<li>
								<router-link :to="{name:'Bossspeak',params:{page:'3'}}">领导致辞</router-link>
							</li>
						</ul>
					</li>
					<li class="drop-down">
						<router-link :to="{name:'worktrend',params:{page:'1'}}">公证动态</router-link>
						<ul class="drop-down-content">
							<li>
								<router-link :to="{name:'worktrend',params:{page:'1'}}">工作动态</router-link>
							</li>
							<li>
								<router-link :to="{name:'worktrend',params:{page:'2'}}">通知公告</router-link>
							</li>
						</ul>
					</li>
					<li class="drop-down" style="cursor:pointer;color: #ffffff;" @click="Switchitem('1')">网上服务

						<ul class="drop-down-content" >
							<li style="color: #ffffff;"  @click.stop="Switchitem('1')">网上咨询</li>
							<li style="color: #ffffff;"  @click.stop="Switchitem('2')">网上预约</li>
							<li style="color: #ffffff;"  @click.stop="Switchitem('3')">网上申办</li>
						</ul>
					</li>
					<li>
						<router-link :to="{name:'Personnel'}">公证员风采</router-link>
					</li>
					<li class="drop-down">
						<router-link :to="{name:'laws',params:{page:'1'}}">法律法规</router-link>
						<ul class="drop-down-content">
							<li>
								<router-link :to="{name:'laws',params:{page:'1'}}">法律法规</router-link>
							</li>
							<li>
								<router-link :to="{name:'laws',params:{page:'2'}}">办证指南</router-link>
							</li>
							<li>
								<router-link :to="{name:'laws',params:{page:'3'}}">学术研究</router-link>
							</li>
						</ul>
					</li>
					<li>
						<router-link :to="{name:'contact'}">联系我们</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		global,
	} from '../api/index.js'
	import {
		webSiteRegister,sendWebPhoneCode,webLogin,isWebSitePhoneRegister,
		webSiteForgetPassWord
	} from '../api/indexapp.js'
	export default {
		name: "headinfo",
		props:{
			islogin:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				logindata:null,
				show:false,
				show2:false,
				sendregmsg:'发送验证码',
				sendforgetmsg:'发送验证码',
				send:null,
				banner:require("../assets/img/banner1.png"),
				grt:"hello",
				ho:new Date().getHours(),
				nowTime: '',
				nowWeek: '',
				title:'',
				open: false,
				open2:false,
				open3:false,
				loginform: {
					phone:null,
					password:null
				},
				loginrules: {
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号长度在11个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
				},
				regform:{},
				regrules:{
					phone: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号长度在11个字符',
							trigger: 'blur'
						}
					],
					pass: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					code: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
					]
				},
				forgetform:{},
				forgetrules:{
						phone: [{
								required: true,
								message: '请输入手机号',
								trigger: 'blur'
							},
							{
								min: 11,
								max: 11,
								message: '手机号长度在11个字符',
								trigger: 'blur'
							}
						],
						pass: [{
								required: true,
								message: '请输入密码',
								trigger: 'blur'
							},
							{
								min: 6,
								max: 20,
								message: '密码长度在 6 到 20 个字符',
								trigger: 'blur'
							}
						],
						password: [{
								required: true,
								message: '请输入密码',
								trigger: 'blur'
							},
							{
								min: 6,
								max: 20,
								message: '密码长度在 6 到 20 个字符',
								trigger: 'blur'
							}
						],
						code: [{
								required: true,
								message: '请输入验证码',
								trigger: 'blur'
							},
						]
					
				},
				hoturl: '/cxWebApi/profile',
				webSiteConfig:null,
			}
		},
		created() {
			this.getTime();
			this.getglobal();
			this.logindata = JSON.parse(sessionStorage.getItem('webopenId'));

			
		},
		watch:{
			islogin(val,old){
				let obj = JSON.parse(sessionStorage.getItem('webopenId'));
				if(this.$props.islogin){
					if(obj==null){
						this.open = true
						this.$message.error('请先登陆！');
					}
				}
			},
			deep: true,
			immediate: true,
		},
		methods: {
			handleClose(){
				this.$parent.onclose();
				this.open = false;
			},
			handleCommand(command){
				if(command == 'out'){
					this.outin();
				}
			},
			outin(){
				sessionStorage.setItem('webopenId',null);
				this.logindata = null;
				this.$router.push({name:'home'}).catch(err =>{})
			},
			login(){
				webLogin(this.loginform).then(res=>{
					if(res.code == 200){
						 // 登陆成功
						 sessionStorage.setItem('webopenId',JSON.stringify(res.data));
						  this.logindata = res.data;
						  this.open = false;
						  this.loginform = {}
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			isreg(){
				isWebSitePhoneRegister({
					phone:this.regform.phone
				}).then(res=>{
					if(res.code != 200){
						this.$message.error(res.msg);
					}
				})
			},
			sendforgetcode(){
				if(this.forgetform.phone == null || this.forgetform.phone == ''){
					this.$message.error('请先填写手机号码');
				}else{
					if(!this.show2){
						sendWebPhoneCode(this.forgetform).then(res=>{
							if(res.code == 200){
								this.getCode2();
								this.$message('发送成功');
							}else{
								this.$message.error(res.msg);
							}
						})
					}
				}
			},
			getCode2() {
			  this.show2 = true
			  this.sendforgetmsg = 60;
			  this.send = setInterval(()=>{
				this.sendforgetmsg--
				if(this.sendforgetmsg==0){
				  this.show2 = false
				  this.sendforgetmsg = '发送验证码'
				  clearInterval(this.send)
				}
			  },1000)
			},
			getCode() {
			  this.show = true
			  this.sendregmsg = 60;
			  this.send = setInterval(()=>{
				this.sendregmsg--
				if(this.sendregmsg==0){
				  this.show = false
				  this.sendregmsg = '发送验证码'
				  clearInterval(this.send)
				}
			  },1000)
			},
			sendregcode(){
				if(this.regform.phone == null || this.regform.phone == ''){
					this.$message.error('请先填写手机号码');
				}else{
					if(!this.show){
						sendWebPhoneCode(this.regform).then(res=>{
							if(res.code == 200){
								this.getCode();
								this.$message('发送成功');
							}else{
								this.$message.error(res.msg);
							}
						})
					}
				}
			},
			forgetsubmit(){
				if(this.forgetform.pass != this.forgetform.password){
					this.$message.error('两次输入的密码不一致！');
				}else{
					this.$refs['forgetform'].validate((valid) => {
						if (valid) {
							webSiteForgetPassWord(this.forgetform).then(res=>{
								if(res.code == 200){
									this.$message('修改密码成功');
									this.forgetform = {}
									this.open3 = false
								}else{
									this.$message.error(res.msg);
								}
							})
						}
					})
				}
				
			},
			reguser(){
				if(this.regform.pass != this.regform.password){
					this.$message.error('两次输入的密码不一致！');
				}else{
					this.$refs['regform'].validate((valid) => {
						if (valid) {
							webSiteRegister(this.regform).then(res=>{
								if(res.code == 200){
									this.$message('注册成功');
									this.regform = {}
									this.open2 = false
								}else{
									this.$message.error(res.msg);
								}
							})
						}
					})
				}
			},
			Switchitem(row){
				// let obj = JSON.parse(sessionStorage.getItem('webopenId'));
				// if(obj==null){
				// 	this.$message.error('请先登陆！');
				// 	this.open = true
				// }else{
				// 	this.$router.push({name:'serve',params: {page:row}}).catch(err =>{})
				// }
				this.$router.push({name:'serve',params: {page:row}}).catch(err =>{})
			},
			getglobal(){
				this.webSiteConfig = JSON.parse(sessionStorage.getItem('webSiteConfig'))
				if(this.webSiteConfig){
					
				}else{
					global().then(res=>{
						this.webSiteConfig = res.data.webSiteConfig
						sessionStorage.setItem('webSiteConfig',JSON.stringify(res.data.webSiteConfig)); 
					})
				}	
			},
			reg(){
				this.open = false;
				this.open2= true;
			},
			showlogin() {
				this.open = true;
				this.title = '欢迎回来！'
			},
			getTime() {
				let nowDate = new Date();
				let wk = nowDate.getDay();
				let date = {
					year: nowDate.getFullYear(),
					month: nowDate.getMonth() + 1,
					date: nowDate.getDate()
				}
				this.nowTime = date.year + '年' + date.month + '月' + date.date + '日';
				let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
				this.nowWeek = weeks[wk];
				
				if(this.ho < 12){
					this.banner = require("../assets/img/morning.png");
				}else if(this.ho < 19){
					this.banner = require("../assets/img/banner1.png");
				}
			}
		},
	}
</script>

<style scope>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
	@import "../assets/css/sliderx.css";
	@import "../assets/css/login.css";

	.login-form {
		text-align: center;
	}

	.register {
		display: flex;
		justify-content: space-between;
	}
	.el-dropdown-menu__item{
		color: #B86E05 !important;
	}
	.el-button--primary{
	padding: 0
	}
</style>
